<!--
오류 라벨 컴포넌트 > 기본 템플릿 (배송조회 상품리스트에서 사용되는 라벨)
---------------------------------------

-->
<template>
    <div class="uk-inline uk-position-relative">
        <!-- 라벨 -->
        <a class="uk-link-reset" :href="'/prods/'+this.prodId+'/error-info/'+this.errorId" target="_blank">
            <span class="uk-label" :class="labelClass" @mouseenter="openView" @mouseleave="closeView">
                {{ labelText }}
            </span>
        </a>

        <!-- 팝업 -->
        <div class="popup" v-show="viewDisplay">
            <!-- 대기 -->
            <div v-show="this.loadState === 'unload'">
                준비중
            </div>

            <!-- 로딩화면 -->
            <div v-show="this.loadState === 'loading'">
                <loading-icon
                    class="uk-text-middle"
                    bg-color="#ccc"
                    fore-color="#333"
                ></loading-icon>
                loading...
            </div>

            <!-- 실제 내용 표시 -->
            <div v-show="this.loadState === 'loaded'">
                {{ error.type_text }}
            </div>
        </div>
    </div>

</template>

<script>
    import Base from './base.vue';

    export default {
        extends: Base,
        components: {
            'loading-icon': require('../../common/loading-icon.vue').default,
        },
        computed: {
            /**
             * 라벨 클래스
             */
            labelClass() {
                return {
                    'currently': ! this.history,
                    'history': this.history,
                };
            },
        },
    }
</script>

<style lang="scss" scoped>
    // 현재 오류중 라벨
    .currently {
        background-color: #f0506e;
        color: #fff;
    }
    // 오류기록 라벨
    .history {
        border: 1px solid #ec2147;
        background-color: #fff;
        color: #ec2147;
    }

    // 팝업
    .popup {
        position: absolute;
        bottom: 20px;
        transform: translateX(-50%);
        width: 200px;

        padding: 10px;
        background-color: rgba(0,0,0,0.8);
        border: 1px solid #666;
        color: #fff;
        font-size: 0.875rem;


        // 요청사항
        .request {
            margin-top: 10px;
            &:first-child {
                margin-top: 0;
            }
        }
    }
</style>